import { render, staticRenderFns } from "./MoreArticles.vue?vue&type=template&id=66444ff6&"
import script from "./MoreArticles.vue?vue&type=script&lang=js&"
export * from "./MoreArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports